import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import Backend from 'i18next-xhr-backend';
import { Formaters } from "lib/Formarters";
import HtmlUtils from "lib/HtmlUtils";
import moment from "moment";
import { initReactI18next } from 'react-i18next';

//////////////////////////////////////////////////////////////////////////////////////////

export function initI18n(callback: any) {
    i18n
        .use(detector)
        .use(Backend)
        .use(initReactI18next) // passes i18n down to react-i18next
        .init({
            compatibilityJSON: 'v2',

            fallbackLng: "pt",

            // have a common namespace used around the full app
            ns: ['clientApp', 'sys', 'log'],

            defaultNS: 'clientApp',

            debug: HtmlUtils.isLocalhost(),

            //resources: resources,

            interpolation: {
                escapeValue: false, // not needed for react!!
                format: function (value, format, lng) {
                    if (value != null) {
                        if (format === 'uppercase') return value.toUpperCase();
                        else if (format === 'lowercase') return value.toLowerCase();
                        else if (format === 'capitalize') return Formaters.capitalize(value);
                        else if (format === 'capitalizeAll') return Formaters.capitalizeAll(value);
                        else if (format === 'toFixed0' && typeof value == "number") return value.toFixed(0);
                        else if (format === 'toFixed2' && typeof value == "number") return value.toFixed(2);
                        else if ((format === 'relativeTime' || format === 'dateL' || format === 'dayMonth' || format === 'hm')
                            && (value instanceof Date || typeof value == "string")
                        ) {
                            const dt = value instanceof Date ? value : new Date(value);
                            if (format === 'relativeTime') return Formaters.relativeTime(dt);
                            else if (format === 'dateL') return Formaters.localeDate(dt);
                            else if (format === 'dayMonth') return Formaters.dayMonth(dt);
                            else if (format === 'hm') return Formaters.localeTime(dt) + "h";
                        }
                        else if (value instanceof Date) return format != null ? moment(value).format(format) : moment(value);
                    }
                    return value;
                }
            },

            backend: {
                loadPath: '/assets/locale/{{ns}}/{{lng}}/translations.json',
            },

            react: {
                useSuspense: true,
                bindI18n: 'languageChanged loaded',
                transEmptyNodeValue: '',
                transSupportBasicHtmlNodes: true,
                transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b'],
            }
        }, (err, t) => {
            callback();
        });
}